<template>
  <a-layout class="canvasLayout">
      <a-layout-content ref="canvas" class="CurtainCanvas">
        <vue-cropper
          ref="cropper"
          :img="option.img.url"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="option.info"
          :full="option.full"
          :fixed="option.fixed"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :fixed-box="option.fixedBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :auto-crop-width="option.autoCropWidth"
          :auto-crop-height="option.autoCropHeight"
          :high="option.high"
          :max-img-size="option.max"
          :center-box="option.centerBox"
          mode="contain"
          @real-time="realTime"
          @img-load="imgLoad"
          @crop-moving="cropMoving"
          @crop-sizing="cropSizing"
          @mousemove.native="realtimeCursor"
        >
        </vue-cropper>
        <div
          class="frame"
          ref="frame"
          :style="{height:frameHeight+'px', width: frameWidth+'px', top: frameY + 'px', left: frameX + 'px'}"
        />
        <!-- 辅助线 -->
        <div class="curtainhead" :style="{top: curtainHead+'px'}"></div>
        <div class="center-cross horizontal" :style="{top:centerCrossHorizontal+'px'}"></div>
        <div class="center-cross vertical" :style="{left:centerCrossVertical+'px'}"></div>
        <!-- loading -->
        <a-spin class="loading" size="large" tip="正在加载..." v-show="loading" />
      </a-layout-content>
      <a-layout-sider width="170" style="background: #dedede;padding:20px 8px;border-left:1px solid #ccc;">
        <CurtainProperty
          :params="properties"
          @propertyChanged="changeProperty"
          @sizeChanged="changeSize"
          @curtainHeadChanged="changeCurtainHead"
          @colorChanged="changeColor"
        />
      </a-layout-sider>
    </a-layout>

</template>

<script>
import { VueCropper } from 'vue-cropper'
import CurtainProperty from './CurtainProperty'

export default {
  components: {
    VueCropper,
    CurtainProperty
  },
  props: ['canvas'],
  data () {
    return {
      id: '',
      option: {
        img: '',
        size: 1,
        full: false,
        outputType: 'png',
        canMove: true,
        fixed: false,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 160,
        autoCropHeight: 160,
        centerBox: true,
        high: true,
        max: 99999,
        info: false,
        // 是否显示整个 frame
        fullPage: false

      },
      // 卷帘属性
      properties: {
        // 卷帘尺寸 cm
        width: 100,
        height: 100,
        curtainHead: 15,
        // 面料
        mianliao: {
          value: 'other',
          other: ''
        },
        // 备注
        note: '',
        // 背景色
        bgColor: '#ffffff',
        // 点击的位置
        cursorX: 0,
        cursorY: 0
      },
      // 网页中的尺寸 px
      frameWidth: 0,
      frameHeight: 0,
      frameX: 0,
      frameY: 0,
      findCursor: false,
      // 辅助线
      curtainHead: 0,
      centerCrossHorizontal: 0,
      centerCrossVertical: 0,
      // loading
      loading: true,
      fromStartUp: true
    }
  },
  created () {
    this.id = this.canvas.id
    // 浅 copy, option 对象修改对源对象同样有效
    Object.assign(this.option, this.canvas.option)
    // properties 是同一个对象, 修改同步
    this.properties = this.canvas.properties

    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    // 实时预览函数
    realTime (data) {
      const cropper = this.$refs.cropper
      const cropAxis = cropper.getCropAxis()
      const imgAxis = cropper.getImgAxis()
      this.$emit('preview-update', {
        id: this.id,
        preview: data,
        option: {
          fullPage: this.option.fullPage,
          img: {
            url: this.option.img.url,
            x: cropper.x,
            y: cropper.y,
            x1: imgAxis.x1,
            y1: imgAxis.y1,
            scale: cropper.scale,
            trueWidth: cropper.trueWidth,
            trueHeight: cropper.trueHeight,
            source: this.option.img.source
          },
          crop: {
            x: cropAxis.x1,
            y: cropAxis.y1,
            cropW: cropAxis.x2 - cropAxis.x1,
            cropH: cropAxis.y2 - cropAxis.y1
          },
          frame: {
            x: this.frameX,
            y: this.frameY,
            width: this.frameWidth,
            height: this.frameHeight
          }
        }
      })
    },
    imgLoad (msg) {
      console.log('imgLoad', msg)

      this.loading = false

      const cropper = this.$refs.cropper
      if (this.fromStartUp) {
        Object.assign(cropper, {
          x: this.option.img.x,
          y: this.option.img.y,
          scale: this.option.img.scale
        })
      }

      this.changeSize({
        width: this.properties.width,
        height: this.properties.height,
        curtainHead: this.properties.curtainHead
      })

      this.$nextTick(_ => {
        this.$el.querySelector('.cropper-face.cropper-move').style.opacity = 0
        cropper.$forceUpdate()
        cropper.showPreview()
        this.$emit('loaded', this.id)
      })

      this.fromStartUp = false
    },
    cropMoving (data) {
      // console.log(data, '截图框当前坐标')
      const axis = data.axis
      // 限制位置在 frame 内
      if (axis.x1 < this.frameX) {
        this.$refs.cropper.cropOffsertX = this.frameX
      } else if (axis.x2 > this.frameX + this.frameWidth) {
        this.$refs.cropper.cropOffsertX = axis.x1 + this.frameX + this.frameWidth - axis.x2
      }
      if (axis.y1 < this.frameY) {
        this.$refs.cropper.cropOffsertY = this.frameY
      } else if (axis.y2 > this.frameY + this.frameHeight) {
        this.$refs.cropper.cropOffsertY = axis.y1 + this.frameY + this.frameHeight - axis.y2
      }
    },
    cropSizing (data) {
      // console.log(data)
      const {cropW, cropH} = data
      const axis = this.$refs.cropper.getCropAxis()
      // limit width, height
      if (axis.x1 + cropW > this.frameX + this.frameWidth) {
        this.$refs.cropper.cropW = this.frameWidth - (axis.x1 - this.frameX)
      }
      if (axis.y1 + cropH > this.frameY + this.frameHeight) {
        this.$refs.cropper.cropH = this.frameHeight - (axis.y1 - this.frameY)
      }
      // limit left, top
      if (axis.x1 < this.frameX) {
        this.$refs.cropper.cropOffsertX = this.frameX
        this.$refs.cropper.cropW = axis.x2 - this.frameX
      }
      if (axis.y1 < this.frameY) {
        this.$refs.cropper.cropOffsertY = this.frameY
        this.$refs.cropper.cropH = axis.y2 - this.frameY
      }
    },
    // 改变卷帘尺寸
    changeSize (params) {
      const {width, height, curtainHead} = params
      if (!(width > 0 && height > 0)) {
        return
      }
      this.properties.width = width
      this.properties.height = height
      this.properties.curtainHead = curtainHead

      const cropper = this.$refs.cropper
      let zoom = 1

      // resize 前的尺寸, 后面要计算 scale 和偏移量
      const ofWidth = this.frameWidth || this.option.frame.width
      const ofHeight = this.frameHeight || this.option.frame.height
      const ofX = this.frameX || this.option.frame.x
      const ofY = this.frameY || this.option.frame.y

      const H = this.$el.querySelector('.CurtainCanvas').clientHeight
      const W = this.$el.querySelector('.CurtainCanvas').clientWidth
      if (!W || !H) {
        return
      }
      // cropper 的 w,h 影响截图框的活动范围
      cropper.w = W
      cropper.h = H

      if (H / W > height / width) {
        // 以 w 作为参考
        this.frameWidth = W - 60
        this.frameX = 30
        this.frameHeight = height * this.frameWidth / width
        this.frameY = (H - this.frameHeight) / 2
      } else {
        // 以 h 作为参考
        this.frameHeight = H - 60
        this.frameY = 30
        this.frameWidth = width * this.frameHeight / height
        this.frameX = (W - this.frameWidth) / 2
      }

      // 辅助线
      this.curtainHead = this.frameY + this.frameHeight * curtainHead / this.properties.height
      this.centerCrossHorizontal = (this.frameY + this.frameHeight + this.curtainHead) / 2
      this.centerCrossVertical = this.frameX + this.frameWidth / 2

      if (ofWidth && ofHeight) {
        zoom = this.frameWidth / ofWidth
        // 调整大小
        const imgAxis = cropper.getImgAxis()
        const px = (ofX - imgAxis.x1) * 2 / (imgAxis.x2 - imgAxis.x1)
        const py = (ofY - imgAxis.y1) * 2 / (imgAxis.y2 - imgAxis.y1)

        cropper.scale *= zoom

        // 调整坐标
        // 图片以中心为原点 scale
        cropper.x += (this.frameX - ofX) - cropper.trueWidth * (cropper.scale / zoom - cropper.scale) * (1 - px) / 2
        cropper.y += (this.frameY - ofY) - cropper.trueHeight * (cropper.scale / zoom - cropper.scale) * (1 - py) / 2
      }

      // 截图框
      if (this.option.fullPage) {
        this.setFullPage()
      } else {
        const cropOpt = {}
        const cropAxis = cropper.getCropAxis()
        if (cropAxis && cropAxis.x1 && cropAxis.y1) {
          Object.assign(cropOpt, {
            x: cropAxis.x1,
            y: cropAxis.y1,
            cropW: cropAxis.x2 - cropAxis.x1,
            cropH: cropAxis.y2 - cropAxis.y1
          })
        } else {
          Object.assign(cropOpt, this.option.crop)
        }
        // zoom
        cropOpt.x = this.frameX + zoom * (cropOpt.x - ofX)
        cropOpt.y = this.frameY + zoom * (cropOpt.y - ofY)
        cropOpt.cropW = zoom * cropOpt.cropW
        cropOpt.cropH = zoom * cropOpt.cropH

        this.setCrop(cropOpt)
      }

      // 采集颜色坐标
      if (this.properties.cursorX && this.properties.cursorY) {
        this.properties.cursorX = this.frameX + zoom * (this.properties.cursorX - ofX)
        this.properties.cursorY = this.frameY + zoom * (this.properties.cursorY - ofY)
      }

      this.$forceUpdate()
    },
    // 改变参数
    changeProperty (properties) {
      this.properties = properties
    },
    // 改变卷帘头
    changeCurtainHead (properties) {
      this.properties = properties
      this.curtainHead = this.frameY + this.frameHeight * properties.curtainHead / this.properties.height
    },
    // 画框鼠标坐标
    realtimeCursor (e) {
      if (this.findCursor) {
        let x = e.offsetX
        let y = e.offsetY
        // 转全局坐标
        if (e.target.classList.contains('cropper-face')) {
          x += this.$refs.cropper.cropOffsertX
          y += this.$refs.cropper.cropOffsertY
        }
        this.properties.cursorX = x
        this.properties.cursorY = y
        this.findCursor = false
      }
    },
    // 改变背景颜色
    changeColor (properties) {
      this.findCursor = true
      this.properties = properties
    },
    onResize () {
      setTimeout(_ => {
        this.changeSize({
          width: this.properties.width,
          height: this.properties.height,
          curtainHead: this.properties.curtainHead
        })
      }, 100)
    },
    // 设置对齐
    setAlignment (type) {
      const axis = this.$refs.cropper.getCropAxis()
      if (type === 'center') {
        // 水平居中
        this.$refs.cropper.cropOffsertX = this.frameX + (this.frameWidth + axis.x1 - axis.x2) / 2
      } else if (type === 'middle') {
        // 垂直居中
        this.$refs.cropper.cropOffsertY = this.frameY + (this.frameHeight + axis.y1 - axis.y2) / 2
      }
    },
    // 选择图片
    choosePicture (data) {
      if (this.option.img.url !== data.image) {
        this.option.img.url = data.image
        this.option.img.source = data
        this.loading = true
      }
    },
    switchCrop () {
      this.option.fullPage = !this.option.fullPage
      if (this.option.fullPage) {
        this.setFullPage()
      } else {
        this.setCrop({cropW: 200, cropH: 200})
      }
    },
    // 隐藏截图框
    setFullPage () {
      const cropper = this.$refs.cropper
      this.option.centerBox = false
      this.option.fixedBox = true
      cropper.cropOffsertX = this.frameX
      cropper.cropOffsertY = this.frameY
      cropper.cropW = this.frameWidth
      cropper.cropH = this.frameHeight
      this.$nextTick(_ => {
        cropper.$el.querySelector('.cropper-crop-box').style['pointer-events'] = 'none'
        setTimeout(cropper.showPreview, 50)
      })
    },
    // 显示截图框
    setCrop (opt) {
      const cropper = this.$refs.cropper
      this.option.centerBox = true
      this.option.fixedBox = false

      cropper.changeCrop(opt.cropW, opt.cropH)

      if (opt.x && opt.y) {
        this.$nextTick(_ => {
          Object.assign(this.$refs.cropper, {
            cropOffsertX: opt.x,
            cropOffsertY: opt.y
          })
          setTimeout(cropper.showPreview, 50)
        })
      }

      cropper.$el.querySelector('.cropper-crop-box').style['pointer-events'] = 'auto'
    },
    // 切换不同的画布时触发
    active () {
      // 当在其它画布时改变了窗口大小
      this.onResize()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.canvasLayout{height:100%;}
.CurtainCanvas {position: relative;overflow:hidden;}
.frame{position:absolute;box-shadow: 0 0 0 10000px rgba(0, 0, 0, 0.65);pointer-events: none;}
.curtainhead{height:0px;width:100%;border-bottom:1px solid green;position:absolute;pointer-events: none;}
.center-cross.horizontal{height:0px;width:100%;border-bottom:1px solid #bbb;position:absolute;pointer-events: none;}
.center-cross.vertical{height:100%;width:0;border-right:1px solid #bbb;top:0;position:absolute;pointer-events: none;}
.loading{position: absolute;bottom:50%;left:50%;}
</style>



// WEBPACK FOOTER //
// src/pages/design/CurtainCanvas.vue